import CarouselItem from './CarouselItem'

export * from './CarouselItem'

export default CarouselItem
